// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Tdu2","label":"Labeled_label__16srG","divider":"Labeled_divider__3S5RZ"};